import React from 'react'
import useStatData from '../../../hooks/useStatData'
import FilterForm from './filters/FilterForm'
import ChartDisplay from './charts/ChartDisplay'
import PropTypes from 'prop-types'
import { useAuth } from '../../molecules/Auth'
import ChartIndicator from './ChartIndicator'

const ChartSection = ({ selectedIndicator, changeIndicator }) => {
  const { initialFilters, fetchFilteredData } = useStatData()
  const { user } = useAuth()
  const currentRole = user.role

  const accessRules = {
    admin: ['users', 'institutions', 'forms', 'answers', 'receivedRequests', 'attendedRequests'],
    coordinator: ['users', 'forms', 'answers', 'receivedRequests', 'attendedRequests'],
    branch_coordinator: ['users', 'forms', 'answers', 'receivedRequests', 'attendedRequests'],
    collaborator: ['forms', 'answers', 'receivedRequests', 'attendedRequests']
  }

  return (
    <div className="chart-section" id="chart-section">
      <div className="py-8 px-6 bg-neutral-100 flex items-center border-b border-gray-350 border-solid flex-wrap md:flex-nowrap">
        <ChartIndicator
          changeIndicator={changeIndicator}
          fetchFilteredData={fetchFilteredData}
          initialFilters={{ indicator: selectedIndicator, ...initialFilters }}
        />
      </div>
      <FilterForm
        initialFilters={initialFilters}
        fetchFilteredData={fetchFilteredData}
        selectedIndicator={selectedIndicator}
        accessRules={accessRules[currentRole]}
      />

      <ChartDisplay
        selectedIndicator={selectedIndicator || initialFilters.indicator}
        accessRules={accessRules[currentRole]}
      />
    </div>
  )
}

ChartSection.propTypes = {
  changeIndicator: PropTypes.func.isRequired,
  selectedIndicator: PropTypes.string.isRequired
}
export default ChartSection
